import styled from '@emotion/styled';
import SimpleBar from 'simplebar-react';

import Heading from 'storybookConfig/stories/molecules/Heading';

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & #settings-header-dropdown {
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const SettingsFooter = styled.footer`
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  padding: 0rem 1.5rem;
  border-top: 1px solid #e3ebf6;
`;

const ScrollWrapper = styled.div`
  flex: 1;
  overflow: auto;
`;

interface SettingsSectionTitleProps {
  children: React.ReactNode;
  as?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const SectionTitleWrapper = styled.div`
  margin-bottom: 4px;
`;

export const SettingsSectionTitle = ({ children, as = 'h4' }: SettingsSectionTitleProps) => (
  <SectionTitleWrapper>
    <Heading variant="Headings/H4" as={as}>
      {children}
    </Heading>
  </SectionTitleWrapper>
);

export const SettingsDescription = styled.p`
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0 0 8px 0;
  line-height: 1.4;
`;

interface SettingsPageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

const PAGE_HEADER_MARGIN_BOTTOM = 16;

export const SettingsPageHeader = ({ title, children }: SettingsPageHeaderProps) => {
  return (
    <>
      <Header className="d-flex justify-space-between align-items-center">
        <div className="d-none d-md-flex align-items-center" style={{ marginRight: 8 }}>
          <Heading variant="Headings/H3" as="h3">
            {title}
          </Heading>
        </div>

        {children && children}
      </Header>
      <hr style={{ marginBottom: PAGE_HEADER_MARGIN_BOTTOM }} />
    </>
  );
};

interface SettingsMainProps {
  children: React.ReactNode;
}

const SETTINGS_CONTENT_PADDING = 24;

export const SettingsMain = ({ children }: SettingsMainProps) => (
  <ScrollWrapper>
    <SimpleBar style={{ height: '100%' }}>
      <div style={{ padding: SETTINGS_CONTENT_PADDING }}>{children}</div>
    </SimpleBar>
  </ScrollWrapper>
);
